import { createSystem, defineConfig, defaultConfig } from '@chakra-ui/react';

const sindiConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        sindiIvory: { value: '#FBFEF4' },
        sindiBone: { value: '#CCC7B7' },
        sindiYellow: {
          50: { value: '#fffbf0' },
          100: { value: '#fff6e0' },
          200: { value: '#ffedc2' },
          300: { value: '#ffe199' },
          400: { value: '#ffd466' },
          500: { value: '#FFAC24' },
          600: { value: '#e6991f' },
          700: { value: '#cc861a' },
          800: { value: '#b37316' },
          900: { value: '#996012' },
          950: { value: '#66400c' },
        },
        sindiCoral: {
          50: { value: '#fef1f5' },
          100: { value: '#fde4ea' },
          200: { value: '#fccdd8' },
          300: { value: '#f9a8bc' },
          400: { value: '#f5759a' },
          500: { value: '#ed4a7a' },
          600: { value: '#dc2f5f' },
          700: { value: '#c21d4a' },
          800: { value: '#a11a3d' },
          900: { value: '#861a35' },
          950: { value: '#4f0f1f' },
        },
        sindiBlue: {
          50: { value: '#eff6ff' },
          100: { value: '#dbebfe' },
          200: { value: '#bfdbfe' },
          300: { value: '#93c2fd' },
          400: { value: '#60a5fa' },
          500: { value: '#3b8ff6' },
          600: { value: '#257eeb' },
          700: { value: '#1d71d8' },
          800: { value: '#1e5faf' },
          900: { value: '#1e4e8a' },
          950: { value: '#173254' },
        },
        sindiPurple: {
          50: { value: '#f5f5fd' },
          100: { value: '#eeecfb' },
          200: { value: '#dedcf8' },
          300: { value: '#c5bff3' },
          400: { value: '#a79bea' },
          500: { value: '#8872e0' },
          600: { value: '#7653d4' },
          700: { value: '#6641c0' },
          800: { value: '#5636a1' },
          900: { value: '#482e84' },
          950: { value: '#2b1c59' },
        },
        sindiCyan: {
          50: { value: '#f0fdfc' },
          100: { value: '#ccfbf6' },
          200: { value: '#99f6ec' },
          300: { value: '#5eeadb' },
          400: { value: '#2dd4c2' },
          500: { value: '#14b8a6' },
          600: { value: '#0d9485' },
          700: { value: '#0f766b' },
          800: { value: '#115e56' },
          900: { value: '#134e48' },
          950: { value: '#042f2a' },
        },
      },
    },
    semanticTokens: {
      colors: {
        'sindi-body-text': {
          value: { _light: '{colors.gray.900}', _dark: '{colors.gray.100}' },
        },
        sindiIcon: {
          value: {
            _light: '{colors.sindiPurple.800}',
            _dark: '{colors.sindiPurple.100}',
          },
        },
        sindiPurple: {
          solid: { value: '{colors.sindiPurple.600}' },
          contrast: { value: '{colors.sindiPurple.100}' },
          fg: { value: '{colors.sindiPurple.700}' },
          muted: { value: '{colors.sindiPurple.100}' },
          subtle: { value: '{colors.sindiPurple.200}' },
          emphasized: { value: '{colors.sindiPurple.300}' },
          focusRing: { value: '{colors.sindiPurple.500}' },
        },

        sindiBlue: {
          solid: { value: '{colors.sindiBlue.600}' },
          contrast: { value: '{colors.sindiBlue.100}' },
          fg: { value: '{colors.sindiBlue.700}' },
          muted: { value: '{colors.sindiBlue.100}' },
          subtle: { value: '{colors.sindiBlue.200}' },
          emphasized: { value: '{colors.sindiBlue.300}' },
          focusRing: { value: '{colors.sindiBlue.500}' },
        },

        sindiCyan: {
          solid: { value: '{colors.sindiCyan.600}' },
          contrast: { value: '{colors.sindiCyan.100}' },
          fg: { value: '{colors.sindiCyan.700}' },
          muted: { value: '{colors.sindiCyan.100}' },
          subtle: { value: '{colors.sindiCyan.200}' },
          emphasized: { value: '{colors.sindiCyan.300}' },
          focusRing: { value: '{colors.sindiCyan.500}' },
        },
        sindiYellow: {
          solid: { value: '{colors.sindiYellow.600}' },
          contrast: { value: '{colors.sindiYellow.100}' },
          fg: { value: '{colors.sindiYellow.700}' },
          muted: { value: '{colors.sindiYellow.100}' },
          subtle: { value: '{colors.sindiYellow.200}' },
          emphasized: { value: '{colors.sindiYellow.300}' },
          focusRing: { value: '{colors.sindiYellow.500}' },
        },
      },
    },
  },
  globalCss: {
    'html, body': {
      color: 'sindi-body-text',
      bg: 'gray.50',
    },
    'table td, table th': {
      fontVariantNumeric: 'normal',
    },
  },
});

export const sindiTheme = createSystem(defaultConfig, sindiConfig);
